<script setup lang="ts">
const props = withDefaults(defineProps<{
  modelValue: string
  placeholder?: string
}>(), {
  placeholder: '#000000'
})

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

const hexRegex = /^#[0-9a-fA-F]{6}$/
const inputValue = ref(props.modelValue)

watch(() => props.modelValue, (v) => {
  inputValue.value = v
})

function commitInput() {
  const trimmed = inputValue.value.trim()
  if (hexRegex.test(trimmed)) {
    emit('update:modelValue', trimmed)
  } else {
    // Revert to current model value
    inputValue.value = props.modelValue
  }
}
</script>

<template>
  <UPopover>
    <div class="flex items-center gap-2 rounded-lg border border-default bg-elevated/50 px-2 py-1.5 cursor-pointer hover:border-accented transition-colors">
      <span
        class="size-4 rounded-full shrink-0 border border-accented"
        :style="{ backgroundColor: modelValue }"
      />
      <input
        v-model="inputValue"
        type="text"
        maxlength="7"
        class="w-full bg-transparent text-xs text-toned font-mono outline-none placeholder:text-dimmed"
        :placeholder="placeholder"
        @blur="commitInput"
        @keyup.enter="($event.target as HTMLInputElement).blur()"
        @click.stop
      >
      <UIcon
        name="i-lucide-pipette"
        class="size-3.5 shrink-0 text-primary-400"
      />
    </div>

    <template #content>
      <UColorPicker
        :model-value="modelValue"
        class="p-2"
        @update:model-value="(v: string) => v !== undefined && emit('update:modelValue', v)"
      />
    </template>
  </UPopover>
</template>
